const GROSTESQUE = 'Darker Grotesque Variable';
const URBANIST = 'Urbanist Variable';
const ARIAL = 'Arial';
const SANS_SERIF = 'sans-serif';

/**
 * Main font-family used with their font-family fallback
 */
export const Fonts = {
  DarkerGrotesque: [GROSTESQUE, ARIAL, SANS_SERIF].join(','),
  Urbanist: [URBANIST, ARIAL, SANS_SERIF].join(','),
};
